import script from "./AdditionalInformationWrapper.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdditionalInformationWrapper.vue?vue&type=script&lang=ts&setup=true"

import "./AdditionalInformationWrapper.vue?vue&type=style&index=0&id=4421d889&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4421d889"]])

export default __exports__